import React from 'react'
import {Card, CardProps, CardHeader, CardHeaderProps, CardContent, CardContentProps} from '@mui/material'
import {makeStyles} from '@oc/styles'
import {DataCyProps} from './dataCyProps'
import {useExtractedClassName} from '@oc/hooks'

const useStyles = makeStyles(theme => ({
    cardHeader: {
        borderBottom: '1px solid rgb(0,0,0,0.12)',
        padding: theme.spacing(1)
    },
    cardTitle: {
        fontWeight: 500
    },
    cardHeaderAction: {
        margin: 0
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0
        }
    }
}))

interface ContainerWithActionsProps extends DataCyProps {
    title: React.ReactNode
    children?: React.ReactNode
    cardProps?: CardProps
    headerProps?: Omit<CardHeaderProps, 'title'> & DataCyProps
    contentProps?: CardContentProps & DataCyProps
}

export function ComponentCard(props: ContainerWithActionsProps) {
    const {classes: styles} = useStyles()

    const [headerClassName, headerPropsWithoutClassName] = useExtractedClassName(styles.cardHeader, props.headerProps)
    const [contentClassName, restContentProps] = useExtractedClassName(styles.cardContent, props.contentProps)

    const {titleTypographyProps, classes, ...restHeaderProps} = headerPropsWithoutClassName || {}
    const [titleClassName, titleTypographyPropsWithoutClassName] = useExtractedClassName(
        styles.cardTitle,
        titleTypographyProps
    )
    const {action, ...otherClasses} = classes || {}

    const finalActionClass = action ? `${styles.cardHeaderAction} ${action}` : styles.cardHeaderAction

    return (
        <Card square data-cy={props['data-cy']} {...props.cardProps}>
            <CardHeader
                className={headerClassName}
                title={props.title}
                {...restHeaderProps}
                classes={{
                    action: finalActionClass,
                    ...otherClasses
                }}
                slotProps={{
                    title: {
                        variant: 'subtitle1',
                        className: titleClassName,
                        ...titleTypographyPropsWithoutClassName
                    }
                }}
            />
            <CardContent className={contentClassName} {...restContentProps}>
                {props.children}
            </CardContent>
        </Card>
    )
}
